import { Component, Input, OnInit } from '@angular/core';
import { CategoryResponse } from 'src/app/core/models/categories/category-response';
import { ProductRS } from 'src/app/core/models/products/product-rs';
import { PropertyFilter } from 'src/app/core/models/store-templates/property-filter';
import { CategoryService } from 'src/app/core/services/api/category.service';
import { ProductService } from 'src/app/core/services/api/product.service';

@Component({
  selector: 'app-dynamic-data-filter',
  templateUrl: './dynamic-data-filter.component.html',
  styleUrls: ['./dynamic-data-filter.component.scss']
})
export class DynamicDataFilterComponent implements OnInit {
@Input() filterObject:PropertyFilter;
@Input() siteId: string;


CategoryResponse: CategoryResponse = {};
productResponse: ProductRS = {};

// Image error flags
productImageError: boolean = false;
categoryImageError: boolean = false;

  constructor(private productService: ProductService,
    private categoryService: CategoryService) { }

  ngOnInit(): void {
    this.initFilterItem();
  }

  initFilterItem() {
    if (this.filterObject.by == PropertyFilter.TypeEnum.CATEGORY_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PARENT_ID) {
      if (this.filterObject.data && this.filterObject.data[0] != null && this.filterObject.data[0] != undefined && this.filterObject.data.length > 0) {
        this.getCategoryById(this.filterObject.data[0]);
      }
    } else if (this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_ID) {
      
      if (this.filterObject.data && this.filterObject.data[0] != null && this.filterObject.data[0] != undefined && this.filterObject.data.length > 0) {
        this.getProductById(this.filterObject.data[0]);
      }
    }
  }

  getCategoryById(id: string) {
    this.categoryService.getCategoryById(this.siteId, id).subscribe(
      (res) => {
        this.CategoryResponse = JSON.parse(JSON.stringify(res));
      },
      (error) => {
        if ((error.code = "001")) {
          //remove elem
          let index = this.filterObject.data.indexOf(id);
          this.filterObject.data.splice(index, 1);
        }
      }
    );
  }


  getProductById(id: string) {
    if (id) {
      this.productService.getProductById(this.siteId, id).subscribe(
        (res) => {
          this.productResponse = JSON.parse(JSON.stringify(res));
        },
        (error) => {
          if ((error.code = "005")) {
            //remove elem
            let index = this.filterObject.data.indexOf(id);
            this.filterObject.data.splice(index, 1);
          }
        }
      );
    }
  }

  // Handle product image loading error
  onProductImageError(): void {
    this.productImageError = true;
  }

  // Handle category image loading error
  onCategoryImageError(): void {
    this.categoryImageError = true;
  }

}
